import PropTypes from 'prop-types'
import React from 'react'
import { connect as formikConnect } from 'formik'
import { adFiltersLabels } from 'src/core/constants'
import { SelectDropdown, Wrapper } from 'SRC/ui/FormElementsNew'

export class Condition extends React.Component {
  getConditionField = () => {
    const { formik } = this.props

    return {
      id: 'condition',
      title: adFiltersLabels['condition'],
      isRequired: !formik.values.isBuying,
      options: [
        {
          id: 'condition-new',
          label: 'Novo',
          value: 'new'
        },
        {
          id: 'condition-used',
          label: 'Polovno',
          value: 'used'
        }
      ],
      onChange: this.onConditionChange,
      value: formik.values.condition
    }
  }

  onConditionChange = value => {
    const { formik } = this.props
    formik.setFieldValue('condition', value)
  }

  render () {
    return (
      <Wrapper>
        <SelectDropdown {...this.getConditionField()} />
      </Wrapper>
    )
  }
}

Condition.propTypes = {
  formik: PropTypes.shape({
    values: PropTypes.object,
    setFieldValue: PropTypes.func
  }).isRequired
}

export default formikConnect(Condition)
